import bindScroll from 'helpers/bindScroll';
import portraitCarousel from 'components/portraitCarousel';

export default function homeShowGroupCarousel(carouselsEndpoint) {
    try {
        let carousels = $('.js-video-carousel');
        let objs = [];

        for (var i = 0; i < carousels.length; i++) {
            let wrapper = $(carousels[i]);
            objs.push({
                wrapper: wrapper,
                init: function () {
                    wrapper.on('init', () => {
                        wrapper.removeClass('hidden');
                    });

                    wrapper.on('setPosition', () => {
                        wrapper.ellipsify();
                    });

                    portraitCarousel({
                        parentContainer: wrapper,
                        options: {
                            endPoint: carouselsEndpoint,
                            params: {
                                slug: wrapper.data('slug'),
                                sectionId: wrapper.data('sectionid')
                            }
                        }
                    });
                }
            });
        }

        new bindScroll(objs);
    } catch (e) {
        console.error('below the fold carousel failed to load', e);
    }
}
